// ============================================
// MERCH COLLECTION PAGE INTERACTIVE FEATURES
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the merch collection page
  if (!document.querySelector('.template-collection[data-collection-handle="merch"]')) {
    return;
  }

  // Add stagger animation to product cards on page load
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach((card, index) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    
    setTimeout(() => {
      card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      card.style.opacity = '1';
      card.style.transform = 'translateY(0)';
    }, index * 50);
  });

  // Add parallax effect to banner on scroll
  const banner = document.querySelector('.collection-banner');
  if (banner) {
    const bannerImage = banner.querySelector('img');
    
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      const parallaxSpeed = 0.5;
      
      if (bannerImage && scrolled < banner.offsetHeight) {
        bannerImage.style.transform = `translateY(${scrolled * parallaxSpeed}px)`;
      }
    });
  }

  // Add "Add to Cart" success animation
  document.addEventListener('click', function(e) {
    if (e.target.matches('.product-card__quick-buy, .product-form__submit')) {
      const button = e.target;
      const originalText = button.textContent;
      
      // Create success ripple effect
      const ripple = document.createElement('span');
      ripple.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        transform: translate(-50%, -50%);
        animation: ripple-out 0.6s ease-out;
        pointer-events: none;
      `;
      
      button.style.position = 'relative';
      button.appendChild(ripple);
      
      setTimeout(() => {
        ripple.remove();
      }, 600);
    }
  });

  // Add hover sound effect (optional - only if audio file exists)
  const addHoverSound = () => {
    const cards = document.querySelectorAll('.product-card');
    const hoverSound = new Audio();
    hoverSound.volume = 0.1;
    
    cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        // Subtle hover feedback
        card.style.transform = 'scale(1.02)';
      });
    });
  };

  // Lazy load images with fade-in effect
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.style.opacity = '0';
          img.addEventListener('load', () => {
            img.style.transition = 'opacity 0.5s ease';
            img.style.opacity = '1';
          });
          observer.unobserve(img);
        }
      });
    });

    document.querySelectorAll('.product-card__image').forEach(img => {
      imageObserver.observe(img);
    });
  }

  // Add filter animation
  const filterButtons = document.querySelectorAll('.facets__button');
  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Add pulse animation when filter is clicked
      button.style.animation = 'pulse 0.3s ease';
      setTimeout(() => {
        button.style.animation = '';
      }, 300);
    });
  });

  // Add custom cursor for product cards (optional enhancement)
  const addCustomCursor = () => {
    const cards = document.querySelectorAll('.product-card');
    
    cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        document.body.style.cursor = 'pointer';
      });
      
      card.addEventListener('mouseleave', () => {
        document.body.style.cursor = 'auto';
      });
    });
  };

  // Initialize custom cursor
  addCustomCursor();

  // Add "New" badge to recently added products (within last 7 days)
  const addNewBadges = () => {
    const cards = document.querySelectorAll('.product-card');
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    
    cards.forEach((card, index) => {
      // For demo purposes, mark first 3 items as new
      if (index < 3) {
        const badge = document.createElement('span');
        badge.className = 'product-card__badge product-card__badge--new';
        badge.textContent = '✨ NEW';
        badge.style.cssText = `
          position: absolute;
          top: 10px;
          left: 10px;
          background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);
          color: white;
          padding: 0.3rem 0.8rem;
          border-radius: 20px;
          font-size: 0.7rem;
          font-weight: 700;
          z-index: 10;
          animation: badge-shine 2s ease-in-out infinite;
        `;
        
        const wrapper = card.querySelector('.product-card__image-wrapper');
        if (wrapper) {
          wrapper.style.position = 'relative';
          wrapper.appendChild(badge);
        }
      }
    });
  };

  // Initialize new badges
  setTimeout(addNewBadges, 500);

  // Add CSS for animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes ripple-out {
      to {
        width: 200px;
        height: 200px;
        opacity: 0;
      }
    }
    
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.05); }
      100% { transform: scale(1); }
    }
    
    @keyframes badge-shine {
      0%, 100% { 
        transform: translateX(0);
        box-shadow: 0 2px 10px rgba(0, 255, 136, 0.3);
      }
      50% { 
        transform: translateX(2px);
        box-shadow: 0 4px 20px rgba(0, 255, 136, 0.5);
      }
    }
  `;
  document.head.appendChild(style);

  // Add scroll-triggered animations for collection title
  const collectionTitle = document.querySelector('.collection-banner__title');
  if (collectionTitle) {
    const titleObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'title-glow 3s ease-in-out infinite';
        }
      });
    });
    
    titleObserver.observe(collectionTitle);
  }

  // Console message for developers
  console.log('%c🔥 Merch Collection Enhanced! 🔥', 
    'background: linear-gradient(135deg, #e94b4b 0%, #ff8c00 100%); color: white; font-size: 20px; padding: 10px; border-radius: 5px;');
});
